export const NEWS_STATUS_PENDING = 0;
export const NEWS_STATUS_PUBLISHED = 1;
export const NEWS_STATUS_DISABLED = 2;

export const NEWS_STATUS_NAME = {
  [NEWS_STATUS_PENDING]: 'Pending',
  [NEWS_STATUS_PUBLISHED]: 'Published',
  [NEWS_STATUS_DISABLED]: 'Disabled',
};


export const NEWS_STATUS_CHOICES = [
  { id: NEWS_STATUS_PENDING, name: NEWS_STATUS_NAME[NEWS_STATUS_PENDING] },
  { id: NEWS_STATUS_PUBLISHED, name: NEWS_STATUS_NAME[NEWS_STATUS_PUBLISHED] },
  { id: NEWS_STATUS_DISABLED, name: NEWS_STATUS_NAME[NEWS_STATUS_DISABLED] },
];

export const HIGHLIGHT_OFF = false;
export const HIGHLIGHT_ON = true;

export const HIGHLIGHT_NAME = {
  [HIGHLIGHT_OFF]: 'No',
  [HIGHLIGHT_ON]: 'Yes',
};

export const HIGHLIGHT_CHOICES = [
  { id: HIGHLIGHT_OFF, name: HIGHLIGHT_NAME[HIGHLIGHT_OFF] },
  { id: HIGHLIGHT_ON, name: HIGHLIGHT_NAME[HIGHLIGHT_ON] },
];

export const HEADLINE_OFF = false;
export const HEADLINE_ON = true;

export const HEADLINE_NAME = {
  [HEADLINE_OFF]: 'No',
  [HEADLINE_ON]: 'Yes',
};

export const HEADLINE_CHOICES = [
  { id: HEADLINE_OFF, name: HEADLINE_NAME[HEADLINE_OFF] },
  { id: HEADLINE_ON, name: HEADLINE_NAME[HEADLINE_ON] },
];

export const DISPLAY_BANNER_STATUS_TO_DISPLAY = 1;
export const DISPLAY_BANNER_STATUS_DISPLAYING = 2;
export const DISPLAY_BANNER_STATUS_EXPIRED = 3;
export const DISPLAY_BANNER_STATUS_DISABLED = 4;

export const DISPLAY_BANNER_STATUS_NAME = {
  [DISPLAY_BANNER_STATUS_TO_DISPLAY]: 'To Display',
  [DISPLAY_BANNER_STATUS_DISPLAYING]: 'Displaying',
  [DISPLAY_BANNER_STATUS_EXPIRED]: 'Expired',
  [DISPLAY_BANNER_STATUS_DISABLED]: 'Disabled',
};

export const DISPLAY_BANNER_STATUS_CHOICES = [
  { id: DISPLAY_BANNER_STATUS_TO_DISPLAY, name: DISPLAY_BANNER_STATUS_NAME[DISPLAY_BANNER_STATUS_TO_DISPLAY] },
  { id: DISPLAY_BANNER_STATUS_DISPLAYING, name: DISPLAY_BANNER_STATUS_NAME[DISPLAY_BANNER_STATUS_DISPLAYING] },
  { id: DISPLAY_BANNER_STATUS_EXPIRED, name: DISPLAY_BANNER_STATUS_NAME[DISPLAY_BANNER_STATUS_EXPIRED] },
  { id: DISPLAY_BANNER_STATUS_DISABLED, name: DISPLAY_BANNER_STATUS_NAME[DISPLAY_BANNER_STATUS_DISABLED] }
];

export const BANNER_STATUS_ENABLED = 1;
export const BANNER_STATUS_DISABLED = 2;

export const BANNER_STATUS_NAME = {
  [BANNER_STATUS_ENABLED]: 'Enabled',
  [BANNER_STATUS_DISABLED]: 'Disabled',
};

export const BANNER_STATUS_CHOICES = [
  { id: BANNER_STATUS_ENABLED, name: BANNER_STATUS_NAME[BANNER_STATUS_ENABLED] },
  { id: BANNER_STATUS_DISABLED, name: BANNER_STATUS_NAME[BANNER_STATUS_DISABLED] }
];


export const NEWS_CATEGORY_PRODUCT_UPDATES = 1;
export const NEWS_CATEGORY_OCHA_BOSS_UPDATES = 2;
export const NEWS_CATEGORY_RESTAUNRANT_TIPS = 4;
export const NEWS_CATEGORY_PROMOTIONS = 8;
export const NEWS_CATEGORY_OTHERS = 16;

export const NEWS_CREATE_CATEGORY_NAMES = {
  [NEWS_CATEGORY_PRODUCT_UPDATES]: 'Ocha POS Updates',
  [NEWS_CATEGORY_OCHA_BOSS_UPDATES]: {
      'vn': 'Ocha Boss Updates',
      'th': 'Ocha Manager Updates',
      'id': 'Ocha Manager Updates',
  }[process.env.REACT_APP_COUNTRY],
  [NEWS_CATEGORY_RESTAUNRANT_TIPS]: 'Restaurant Tips',
  [NEWS_CATEGORY_PROMOTIONS]: 'Promotions',
  [NEWS_CATEGORY_OTHERS]: 'Others',
};

export const NEWS_CREATE_CATEGORY_CHOICES = [
  { id: NEWS_CATEGORY_PRODUCT_UPDATES, name: NEWS_CREATE_CATEGORY_NAMES[NEWS_CATEGORY_PRODUCT_UPDATES] },
  { id: NEWS_CATEGORY_OCHA_BOSS_UPDATES, name: NEWS_CREATE_CATEGORY_NAMES[NEWS_CATEGORY_OCHA_BOSS_UPDATES] },
  { id: NEWS_CATEGORY_RESTAUNRANT_TIPS, name: NEWS_CREATE_CATEGORY_NAMES[NEWS_CATEGORY_RESTAUNRANT_TIPS] },
  { id: NEWS_CATEGORY_PROMOTIONS, name: NEWS_CREATE_CATEGORY_NAMES[NEWS_CATEGORY_PROMOTIONS] },
  { id: NEWS_CATEGORY_OTHERS, name: NEWS_CREATE_CATEGORY_NAMES[NEWS_CATEGORY_OTHERS] },
];



// WEBPACK FOOTER //
// ./src/routes/news/utils.js